import { Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Home from './components/Home';
import Uploader from './components/Uploader';
import MediaUploader from './components/MediaUploader/MediaUploader';
import MediaUploaderNew from './components/MediaUploader/MediaUploaderNew';
import MediaUploaderNewView from './components/MediaUploader/MediaUploaderNewView';

import ImageView from './components/ImageView';

import './App.css';

function App() {
  return (
    <SnackbarProvider maxSnack={3}>
      <div className="App">
        <Route exact path="/" component={Home} />
        <Route exact path="/uploader" component={Uploader} />
        <Route exact path="/view" component={ImageView} />
        <Route exact path="/media-uploader/:SFMediaSubmissionID" component={MediaUploader} />
        <Route exact path="/media-uploader-new/:SFMediaSubmissionID" component={MediaUploaderNew} />
        <Route exact path="/media-uploader-new/:SFMediaSubmissionID/view" component={MediaUploaderNewView} />
      </div>
    </SnackbarProvider>
  );
}

export default App;
